import "./Home.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import PawsItivelyPerfectGrooming from "./sections/PawsItivelyPerfectGrooming";
import TheEssence from "./sections/TheEssence";
import ShopBySpecies from "./sections/ShopBySpecies";
import WhyAWhiskersKitten from "./sections/WhyAWhiskersKitten";
import GuestExperiences from "./sections/GuestExperiences";
import ReadyForKickoff from "./sections/ReadyForKickoff";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigationHeader />
      <PawsItivelyPerfectGrooming />
      <TheEssence />
      <ShopBySpecies />
      <WhyAWhiskersKitten />
      <GuestExperiences />
      <ReadyForKickoff />
      <Footer />
    </div>;
}